import { render, staticRenderFns } from "./buyFund.vue?vue&type=template&id=6913e1ee"
import script from "./buyFund.vue?vue&type=script&lang=js"
export * from "./buyFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports